import { useParams } from 'react-router';
import { useESimDetail } from './hooks/useESimDetail';

import { useTranslation } from 'react-i18next';
import { RefetchQueryButton } from 'src/common/components/Queries/RefetchQueryButton';
import {
  PanelCard,
  PanelCardContent,
  Panels,
} from 'src/common/components/Layouts/PanelCard/PanelCard';
import { eSimProductsQueries } from '../utils/esimProductsQueries';
import { SectionGridItem } from 'src/common/components/SectionGrid/SectionGridItem';
import Box from '@mui/material/Box';
import { ESimProfilePanel } from './ESimProfilePanel';
import { useState } from 'react';
import { Button } from 'src/common/components/Buttons/Button';
import { ESimAddProfileDialog } from '../Inventory/Profiles/actions/ESimAddProfileDialog';
import { ESimDetailsSuspense } from './ESimDetailsSuspense';
import { SuspenseLoadingView } from 'src/common/components/SuspenseLoadingView';

export const ESimDetailsContent = () => {
  const { eid } = useParams<{ eid: string }>();
  if (!eid) {
    throw new Error('No eid');
  }

  const { t } = useTranslation();
  const { data } = useESimDetail({ eid });

  const [addProfileDialogOpen, setAddProfileDialogOpen] = useState(false);

  return (
    <>
      <Panels>
        <PanelCard>
          <PanelCardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <SectionGridItem
                label={t('products.eSim.details.setcions.esim.eid')}
                testId="esimEid"
                value={data.eid}
              />
              <Box sx={{ display: 'flex', gap: 16 }}>
                <RefetchQueryButton queryKey={eSimProductsQueries.esim({ eid })} />
                <Button variant="secondary" onClick={() => setAddProfileDialogOpen(true)}>
                  {t('products.eSim.inventory.actions.addESimProfile.title')}
                </Button>
              </Box>
            </Box>
          </PanelCardContent>
        </PanelCard>
        {data?.esimProfiles.items.map((data) => {
          return <ESimProfilePanel data={data} esimEid={eid} key={data.iccid} />;
        })}
      </Panels>
      <ESimAddProfileDialog
        open={addProfileDialogOpen}
        onClose={() => {
          setAddProfileDialogOpen(false);
        }}
        data={{
          eid,
        }}
      />
    </>
  );
};

export const ESimDetails = () => {
  const { eid } = useParams<{ eid: string }>();
  return (
    <SuspenseLoadingView
      queryKey={eSimProductsQueries.esim({ eid: eid! })}
      loadFallback={<ESimDetailsSuspense />}
    >
      <ESimDetailsContent />
    </SuspenseLoadingView>
  );
};
